import React, { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBuilder } from '../components/TrustBuilder';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AdaptabilitySection } from '../components/AdaptabilitySection';
import { ResultsGrid } from '../components/ResultsGrid';
import { AuthorityBlock } from '../components/AuthorityBlock';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  return <main className="min-h-screen bg-stark-white" data-id="element-168">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-169" />
      <HeroSection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-170" />
      <TrustBuilder data-id="element-171" />
      <ProblemSection data-id="element-172" />
      <SolutionSection data-id="element-173" />
      <AdaptabilitySection data-id="element-174" />
      <ResultsGrid data-id="element-175" />
      <AuthorityBlock data-id="element-176" />
      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-177" />
      <Footer data-id="element-178" />

      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-179" />
    </main>;
}